import {
  FilterCategory,
  RangeFilterCategory,
  MultiOptionCategory,
} from './types';
import { Range } from 'react-input-range';

export function isRangeFilter(x: any): x is RangeFilterCategory {
  return (x as RangeFilterCategory).activeMax !== undefined;
}

export function isRangeValue(x: any): x is Range {
  const val = x as Range;
  return val.min !== undefined && val.max !== undefined;
}

export function isMultiFilter(x: any): x is MultiOptionCategory {
  return (x as MultiOptionCategory).options !== undefined;
}

export function isFilterCategory(x: any): x is FilterCategory {
  return (x as FilterCategory).closed !== undefined;
}
